export default __webpack_public_path__ + "static/media/393e94e9f41fe028d5211c01a2ad90711581600870110.6bc33cf6.webp";